import {FunctionComponent, HTMLAttributes, useMemo, CSSProperties} from 'react';

type Props = HTMLAttributes<HTMLDivElement> & {
  currentStep?: number;
  totalSteps?: number;
};

const ContainerCardHeader: FunctionComponent<Props> = ({children, currentStep, totalSteps}) => {
  const progress = useMemo(() => {
    if (currentStep === undefined || totalSteps === undefined) return;
    if (currentStep < 0) return 100;

    return Math.round((currentStep / totalSteps) * 100);
  }, [currentStep, totalSteps]);

  const style = {'--value': `${progress || 0}%`} as CSSProperties;

  return (
    <header className="sticky top-0 z-20 mb-14 flex flex-col bg-white pt-6">
      <div className="pb-4">{children}</div>

      {progress !== undefined && (
        <progress
          className="h-[4px] w-full rounded-1 [&::-moz-progress-bar]:bg-purple-600 [&::-webkit-progress-bar]:rounded-1 [&::-webkit-progress-bar]:bg-purple-600 [&::-webkit-progress-value]:rounded-1 [&::-webkit-progress-value]:bg-violet [&::-webkit-progress-value]:transition-all [&::-webkit-progress-value]:duration-300"
          style={style}
          value={progress}
          max={100}
        ></progress>
      )}
    </header>
  );
};

export default ContainerCardHeader;
